/* iter561 — Dashboard Mode Toggle (Лесен / Стандарт / Експертен).
 *
 * Segmented control in DashboardHeader (top right on desktop).
 * Default: "Лесен". Switching to "Експертен" surfaces a soft toast warning
 * about clinical-grade data; no modal block — user freedom.
 */
import React from "react";
import { Leaf, Layout, Stethoscope } from "lucide-react";
import { toast } from "sonner";
import { useDashboardMode } from "@/dashboard/DashboardModeContext";

const OPTIONS = [
  {
    value: "easy",
    label: "Лесен",
    icon: Leaf,
    tooltip: "Прости точки + цветове",
  },
  {
    value: "standard",
    label: "Стандарт",
    icon: Layout,
    tooltip: "Бюджет % + индекси",
  },
  {
    value: "expert",
    label: "Експертен",
    icon: Stethoscope,
    tooltip: "Грамове, формули, медицински референции",
  },
];

export default function ModeToggle() {
  const { mode, setMode } = useDashboardMode();

  const handleChange = (next) => {
    if (next === mode) return;
    setMode(next);
    if (next === "expert") {
      toast(
        "Експертният режим показва клинични данни (g DIL, NIS PIRU, формули). Препоръчан за лекари и подготвени потребители.",
        { duration: 5000, icon: "🩺" }
      );
    } else if (next === "easy") {
      toast.success("Превключи на Лесен режим. Опростен изглед.", {
        duration: 3000,
      });
    } else {
      toast.success("Превключи на Стандарт режим.", { duration: 3000 });
    }
  };

  return (
    <div
      role="radiogroup"
      aria-label="Режим на показване"
      data-testid="dashboard-mode-toggle"
      className="inline-flex items-center bg-stone-100 border border-stone-200 rounded-full p-0.5 gap-0.5"
    >
      {OPTIONS.map((opt) => {
        const Icon = opt.icon;
        const active = mode === opt.value;
        return (
          <button
            key={opt.value}
            role="radio"
            aria-checked={active}
            type="button"
            title={opt.tooltip}
            data-testid={`dashboard-mode-${opt.value}`}
            onClick={() => handleChange(opt.value)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 ${
              active
                ? "bg-white text-stone-900 shadow-sm"
                : "text-stone-500 hover:text-stone-700"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
